// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentBookIconSignature {
  Element: SVGSVGElement;
}

export const ContentBookIcon: TOC<ContentBookIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 4H14C13.734 4 13.48 4.105 13.293 4.293L12 5.586L10.707 4.293C10.52 4.106 10.266 4 10 4H3C2.447 4 2 4.449 2 5V18C2 18.552 2.447 19 3 19H9.586L11.293 20.707C11.488 20.903 11.744 21 12 21C12.256 21 12.512 20.902 12.707 20.707L14.414 19H21C21.553 19 22 18.552 22 18V5C22 4.449 21.553 4 21 4ZM10 17H4V6H9.586L11 7.415V17.587L10.707 17.294C10.52 17.106 10.266 17 10 17ZM14 17H20V6H14.414L13 7.415V17.586L13.293 17.293C13.48 17.105 13.734 17 14 17Z"/>
</svg>
</template>;